<template>
  <div class="attribute" :class="{ 'without-margin': selectedStore && selectedStore.stock <= 0 }">
    <div class="attr-label"><p>{{ label }}</p></div>
    <div class="attr-items">
      <div class="insurances" v-if="insurances.length">
        <div class="item" :class="{ 'active' : withInsurance }" @click.prevent="addInsurance">Oui</div>
        <div class="item" :class="{ 'active' : !withInsurance }" @click.prevent="removeInsurance">Non</div>
      </div>
      <InsuranceSlider v-if="insurances.length && withInsurance" :insurances="insurances" :selected="modelValue" @change="selectInsurance"/>
    </div>
  </div>
</template>

<script>
import InsuranceSlider from '../InsuranceSlider'

import { mapState } from 'vuex'

export default {
  name: 'Insurance',
  props: {
    modelValue: Object,
    label: String
  },
  data () {
    return {
      withInsurance: false
    }
  },
  mounted () {
    if(this.phone.defaults.insurance){
      this.withInsurance = true
    }
  },
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      insurances: state => state.phone.insurances,
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  },
  methods: {
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },
    selectInsurance (insurance) {
      this.$emit('update:modelValue', insurance)
      this.$emit('change')
    },
    removeInsurance () {
      this.withInsurance = false
      this.$emit('change-insurance', false)
    },
    addInsurance () {
      this.withInsurance = true
      this.$emit('change-insurance', true)
    }
  },
  components: {
    InsuranceSlider
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.attribute{
  margin-bottom: 20px;

  &.without-margin{
    margin-bottom: 0;
  }

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontRegular;
    }
  }

  .attr-items{
    .item{
      width: auto;
      height: 50px;
      line-height: 28px;
      border: 1px solid darken($white, 10%);
      margin: 0 10px 0 0;
      position: relative;
      cursor: pointer;
      padding: 10px 15px 10px 15px;
      text-transform: capitalize;
      @include radius(5px);
      @include transition();

      .inner {
        width: auto;
      }

      &:after {
        display: inline-block;
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border: 2px solid $black;
        opacity: 0;
        @include radius(5px);
        @include transition();
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;

        &:after {
          opacity: 1;
          border: 2px solid $primary;
        }
      }
    }
  }
}
</style>
